import type { FunctionComponent } from 'react';
import { useSuburbPageQuery } from '../../graphql/useSuburbPageQuery';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { LinkCollection } from '../../../components/LinkCollection/LinkCollection';

export const SuburbPageStreetsWithData: FunctionComponent = () => {
  const streets = useSuburbPageQuery()?.data?.suburbPageBySlug?.streets;
  if (!streets) return null;

  const {
    title,
    subtitle,
    items: { visible, hidden },
    showMoreButton,
  } = streets;

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <LinkCollection
        visible={visible}
        hidden={hidden}
        showMoreButtonText={showMoreButton?.title}
      />
    </ContentBrick>
  );
};
